import React, { Component } from 'react'
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { API_URL_NEW, PUBLIC_IMG_URL } from '../../../src/lib/endpoints';
import { isValidEmail } from '../../lib/helpers';
import { ERROR_MESSAGES } from '../../../src/lib/errorMessages';

class DemoRequest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isProcessing: false,
            isSuccess: false,
            isDemoForm: false,
            errorMsg: ''
        }
    }

    handleRequest = () => {
        if (this.state.isProcessing) return;

        if (this.props.user.is_loggedin) {
            //send email from user profile but allow them to change it if they want to
            this.setState({email: this.props.user.email})
        }
        this.setState({isDemoForm: true})
    }

    submitRequest = () => {
        if (this.state.email && this.state.email != '' && isValidEmail(this.state.email)) {
            this.makeAPIcall();
        } else {
            this.setState({errorMsg: 'Please enter a valid email address'});
        }
    }

    handleInput = (e) => {
        const { value } = e.target;
        this.setState({email: value})
    }

    makeAPIcall = () => {
        return new Promise(async (resolve, reject) => {

            try {
                let strPage = "-";
                if (this.props.page) {
                    strPage = this.props.page;
                }

                const body = {
                    email: this.state.email,
                    page: strPage
                };

                const config = {
                    method: 'POST',
                    url: `${API_URL_NEW}/demo-request`,
                    data: body
                };

                await axios(config);
                this.setState({
                    isProcessing: false,
                    errorMsg: "",
                    isSuccess: true,
                    isDemoForm: false
                });

            } catch (error) {
                //TODO ive seen errors from this
                console.log(error);
                this.handleError(error);
            }
        });
    }

    handleError = (error) => {
        let msg = ERROR_MESSAGES.GENERAL_SHORT_ERROR_MSG;
        if (error.response && error.response.data && !isEmpty(error.response.data.errors) && error.response.data.errors[0].message) {
            msg = error.response.data.errors[0].message;
        }

        this.setState({ isProcessing: false });
    }

    closePopup = () => {
        this.setState({
            isProcessing: false,
            isSuccess: false,
            isDemoForm: false,
            errorMsg: false
        });
    }

    renderSuccessPopup = () => {
        let content = null;

        if (this.state.isSuccess) {
            document.body.style.overflow = 'hidden';
            content = (
                <div className="forgot popup" style={{ height: 'auto', overflowY: 'hidden' }}>
                    <a className="close" onClick={this.closePopup}>
                        <img src={`${PUBLIC_IMG_URL}/icons/close.png`} alt="" />
                    </a>
                    <div className="title">
                        <h3 style={{ paddingTop: 20 }}>Demo Request</h3>
                    </div>
                    <div className="content">
                        <p style={{ padding: '0px 15px 15px 20px', margin: '0px' }}>Your request has been received and a member of our team will contact you to find the time that suits you! </p>
                    </div>
                    <div className="buttons">
                        <a className="redButton closeButton" onClick={this.closePopup}>CLOSE</a>
                    </div>
                </div>
            )
        }

        return content;
    }

    renderDemoForm = () => {
        let content = null;

        if (this.state.isDemoForm) {
            document.body.style.overflow = 'hidden';
            content = (
                <div className="forgot popup" style={{ height: 'auto', overflowY: 'hidden' }}>
                    <a className="close" onClick={this.closePopup}>
                        <img src={`${PUBLIC_IMG_URL}/icons/close.png`} alt="" />
                    </a>
                    <div className="title">
                        <h3 style={{ paddingTop: 20 }}>Demo Request</h3>
                    </div>
                    <div className="content" style={{ padding: 15 }}>
                        <input type="email" name="email" placeholder="Email Address" value={this.state.email} className="emailInput" onChange={this.handleInput} style={{ width: "100%", marginBottom: 8 }}/>
                        <div className="red">
                            {this.state.errorMsg}
                        </div>
                    </div>
                    <div className="buttons">
                        <a className="redButton closeButton" onClick={this.submitRequest}>SUBMIT</a>
                    </div>
                </div>
            )
        }

        return content;
    }

    render() {
        const { isProcessing} = this.state;

        return (
            <React.Fragment>
                {this.state.isSuccess && <div className="filterBackground" onClick={this.closePopup}></div>}
                {this.state.isDemoForm && <div className="filterBackground" onClick={this.closePopup}></div>}
                {this.renderSuccessPopup()}
                {this.renderDemoForm()}
                <a onClick={this.handleRequest} className={this.props.btnClasses} id={this.props.id}>
                    {isProcessing && <i className="fas fa-circle-notch fa-spin red" style={{ marginRight: 3 }}></i>}
                    <span style={{ color: "#fff" }}>{this.props.btnText}</span>
                </a>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.userReducer
})

export default connect(mapStateToProps, null)(withRouter(DemoRequest));
